<div class="max-w-6xl mx-auto">
  <div class="max-w-4xl mx-auto p-6">
    <h1 class="text-2xl font-bold mb-4">
      Terms and Conditions for Hype Nation Investments Private Limited
    </h1>
    <p class="text-sm text-gray-500 mb-6">Last Updated: 7 October 2024</p>

    <p class="mb-4">
      Welcome to Hype Nation Investments Private Limited! These Terms and
      Conditions govern your use of our website and services. By accessing or
      using our services, you agree to comply with and be bound by these Terms.
    </p>

    <h2 class="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
    <p class="mb-4">
      By using our website and purchasing tickets through Hype Nation
      Investments, you agree to these Terms and Conditions. If you do not agree,
      please do not use our services.
    </p>

    <h2 class="text-xl font-semibold mb-2">2. General Conditions of Use</h2>
    <ul class="list-disc list-inside mb-4">
      <li>
        You must be at least 18 years old or have parental consent to use our
        website.
      </li>
      <li>
        You agree to use the website solely for personal, non-commercial
        purposes.
      </li>
      <li>
        You must not misuse the website by knowingly introducing viruses,
        trojans, worms, or other malicious material.
      </li>
      <li>
        Hype Nation Investments reserves the right to terminate or suspend your
        access to the website at any time, without notice, for any violation of
        these Terms.
      </li>
    </ul>

    <h2 class="text-xl font-semibold mb-2">3. Booking Process</h2>
    <ul class="list-disc list-inside mb-4">
      <li>
        <strong>Search for Events:</strong> Browse our website to find events
        you wish to attend.
      </li>
      <li>
        <strong>Select Tickets:</strong> Choose your preferred tickets and the
        number of tickets you wish to purchase.
      </li>
      <li>
        <strong>Create an Account:</strong> You may be required to create an
        account or log in to complete your purchase.
      </li>
      <li>
        <strong>Payment:</strong> Enter your payment details to complete the
        transaction. A valid payment method is required.
      </li>
      <li>
        <strong>Confirmation:</strong> Upon successful payment, you will receive
        a confirmation email with your ticket details. Please keep this email as
        proof of purchase.
      </li>
    </ul>

    <h2 class="text-xl font-semibold mb-2">
      4. Prices, Payment, and Placing Orders
    </h2>
    <ul class="list-disc list-inside mb-4">
      <li>
        <strong>Prices:</strong> All ticket prices are displayed on our website
        and are subject to change without notice. Prices include applicable
        taxes and fees unless stated otherwise.
      </li>
      <li>
        <strong>Payment Methods:</strong> We accept various payment methods,
        including credit/debit cards and other online payment systems as
        indicated during the checkout process.
      </li>
      <li>
        <strong>Placing Orders:</strong> You must provide accurate and complete
        information during the booking process. By placing an order, you confirm
        that you have the legal capacity to enter into a binding contract.
      </li>
      <li>
        <strong>Transaction Security:</strong> All transactions are processed
        using secure technology. We take the security of your payment
        information seriously and implement appropriate measures to protect it.
      </li>
    </ul>

    <h2 class="text-xl font-semibold mb-2">5. Ticket Rights and Obligations</h2>
    <ul class="list-disc list-inside mb-4">
      <li>
        <strong>Ownership:</strong> Upon purchase, you will receive a ticket
        granting you the right to attend the specified event. This ticket is
        non-transferable unless otherwise stated.
      </li>
      <li>
        <strong>Entry:</strong> Admission to the event is subject to the terms
        set by the event organizer, including age restrictions and capacity
        limits. It is your responsibility to comply with these terms.
      </li>
      <li>
        <strong>Conditions of Use:</strong> You may not resell or attempt to
        resell tickets purchased through our platform without our express
        written consent.
      </li>
      <li>
        <strong>Lost or Stolen Tickets:</strong> Hype Nation Investments is not
        responsible for lost or stolen tickets. If you lose your ticket, contact
        our customer service for assistance.
      </li>
      <li>
        <strong>Event Changes:</strong> Hype Nation Investments is not liable
        for any changes to the event, including date, time, venue, or lineup
        changes. You are encouraged to check for updates before the event.
      </li>
    </ul>

    <h2 class="text-xl font-semibold mb-2">6. Event Timings and Admissions</h2>
    <ul class="list-disc list-inside mb-4">
      <li>
        <strong>Event Timings:</strong> Event times are specified on our website
        and are subject to change by the event organizer. Check the details
        prior to attendance.
      </li>
      <li>
        <strong>Admission:</strong> Late arrivals may be subject to restrictions
        on entry.
      </li>
      <li>
        <strong>Age Restrictions:</strong> Some events may have age
        restrictions. Ensure compliance before attending.
      </li>
      <li>
        <strong>Health and Safety Compliance:</strong> All attendees must comply
        with health and safety guidelines, including vaccination requirements,
        mask mandates, or social distancing measures.
      </li>
    </ul>

    <h2 class="text-xl font-semibold mb-2">
      7. Refund and Cancellation Policy
    </h2>
    <p class="mb-4">
      All sales are final. No refunds or exchanges will be granted unless the
      event is canceled or rescheduled. In the event of cancellation, customers
      will be notified and offered a full refund.
    </p>

    <h2 class="text-xl font-semibold mb-2">8. User Account</h2>
    <p class="mb-4">
      You may be required to create an account to purchase tickets. You are
      responsible for maintaining the confidentiality of your account
      information and all activities under your account.
    </p>

    <h2 class="text-xl font-semibold mb-2">9. Use of the Website</h2>
    <p class="mb-4">
      You agree not to use the website for any unlawful purpose or in a way that
      may damage, disable, or impair the website. Unauthorized copying,
      distribution, or use of content from our site is prohibited.
    </p>

    <h2 class="text-xl font-semibold mb-2">10. Intellectual Property</h2>
    <p class="mb-4">
      All content, trademarks, and other intellectual property on the website
      are owned by Hype Nation Investments or its licensors. You may not
      reproduce, distribute, or create derivative works from any content without
      permission.
    </p>

    <h2 class="text-xl font-semibold mb-2">11. Limitation of Liability</h2>
    <p class="mb-4">
      Hype Nation Investments is not liable for indirect, incidental, or
      consequential damages arising from your use of the website or ticket
      purchases. Our total liability shall not exceed the amount paid for the
      ticket in question.
    </p>

    <h2 class="text-xl font-semibold mb-2">12. Indemnification</h2>
    <p class="mb-4">
      You agree to indemnify and hold harmless Hype Nation Investments, its
      affiliates, and their officers, directors, and employees from any claims,
      damages, losses, or expenses arising from your use of our services.
    </p>

    <h2 class="text-xl font-semibold mb-2">13. Governing Law</h2>
    <p class="mb-4">
      These Terms and Conditions shall be governed by and construed in
      accordance with the laws of Zimbabwe.
    </p>

    <h2 class="text-xl font-semibold mb-2">14. Changes to Terms</h2>
    <p class="mb-4">
      We reserve the right to modify these Terms and Conditions at any time. Any
      changes will be posted on this page with an updated effective date.
      Continued use of the website after any changes constitutes acceptance of
      the new Terms.
    </p>

    <h2 class="text-xl font-semibold mb-2">15. Photographs / Videos taken at the event</h2>
    <p class="mb-4">
      The organiser and/or Hype Nation and their service providers reserve the right to use any photograph/video taken at any organized or sponsored event, without the expressed written permission of those included within the photograph/video. The organiser and/or Hype Nation and their service providers may use the photograph/video in publications or other media material produced, used or contracted, including but not limited to; brochures, invitations, newspapers, magazines, presentations, websites, etc. A person attending an event who does not wish to have their image recorded for distribution should make their wishes known to the photographer, and/or the event organizers, in writing of his/her intentions. By participating in an event or by failing to notify, in writing, your desire to not have your photograph used by the organiser and/or Hypenation, you are agreeing to release, defend, hold harmless and indemnify the organiser and/or Hypenation from any and all claims involving the use of your picture or likeness. Any person or organization not affiliated with the organiser and/or Hypenation may not use, copy, alter or modify the photographs, graphics, videography or other, similar reproductions or recordings without the advance written permission of an authorized designee of the organiser and/or Hypenation.
    </p>

    <h2 class="text-xl font-semibold mb-2">16. Contact Us</h2>
    <p class="mb-4">
      If you have any questions about these Terms and Conditions, please contact
      us at
      <a href="mailto:admin@hypenation.co.zw" class="text-blue-500 underline"
        >admin&#64;hypenation.co.zw</a
      >.
    </p>
  </div>
</div>
